import React from 'react';
import caise_negative from '../assets/logos/caise_negative.svg';

const LogoIcon = () => {
  const style = {
    minWidth: '30px',
    minHeight: '26px',
    width: '100%',
    height: '100%',
   }
  return <img src={caise_negative} alt="Logo of CAISE project" style={style}/>
};

export default LogoIcon;
